<template>
  <div class="aup-public-profile-camera row">
	  <BaseGearCard
	  	v-for="camera in gearCameras" :key="camera.ppd_gear_lockerid"
		class="aup-public-profile-camera__camera-item mb-4 col-12 f-flex"
		:class="`${ camera.ppd_maincamera || gearCameras.length === 1 ? ' col-md-8 order-1 col-xl-6' : ' col-md-4 col-xl-3 order-2'}`"
		:isMainCamera="camera.ppd_maincamera || gearCameras.length === 1"
		:name="cameraDictionary[camera.ppd_model].name"
		:model="camera.ppd_model"
		:image="cameraDictionary[camera.ppd_model].imageUrl"
		:gearLink="cameraDictionary[camera.ppd_model].productUrl"
		/>
  </div>
</template>
<script>
import { API_GET_PUBLIC_PROFILE, API_GET_EQUIPMENT} from "@/api-service.js";
import { PROFILE_CONSTANTS } from "@/PROFILE_CONSTANTS";

export default {
  name: "Cameras",
  props: {
    gearCameras: {
      type: Array,
      default: () => []
    },
	utmCodesUsage: {
    	type: String,
		default:''
	},
  },
	data(){
      return {
          equipment: {}
	  };
  },
  computed: {
    cameraDictionary() {
      let dictionary = {};
      if(this.equipment.SONY_CAMERAS) {
          this.equipment.SONY_CAMERAS.forEach(camera => {
              dictionary[camera.model] = camera;
          });
      }

      //Add utm codes to cameras url
      if(this.utmCodesUsage && this.equipment.UTM_CODES) {
		  const utmToUse = this.equipment.UTM_CODES.find(el => el.useage === this.utmCodesUsage);
		  if(utmToUse) {
		  	for(let camera in dictionary) {
				dictionary[camera].productUrl = dictionary[camera].productUrl + utmToUse.utmCode;
			}
		  }
	  }

      return dictionary;
	},
  },
    created: async function() {
        const equipmentResponse = await API_GET_EQUIPMENT();
        if (equipmentResponse.status === 200) {
            this.equipment = equipmentResponse.data;
        }
    },
  methods: {
  }
};
</script>
